import { render, staticRenderFns } from "./time-renderer.vue?vue&type=template&id=310f1956&"
import script from "./time-renderer.vue?vue&type=script&lang=js&"
export * from "./time-renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports